import {
    ADD_ADMIN_FAIL,
    ADD_ADMIN_SUCCESS,
    DELETE_ADMIN_FAIL,
    DELETE_ADMIN_SUCCESS,
    EXPORT_ADMIN_FAIL,
    EXPORT_ADMIN_SUCCESS,
    GET_ADMIN_DETAILS_FAIL,
    GET_ADMIN_DETAILS_SUCCESS,
    GET_ADMIN_LISTING_FAIL,
    GET_ADMIN_LISTING_SUCCESS,
    RESET_ADMIN_ACTION_STATE,
    RESET_ADMIN_STATE,
    UPDATE_ADMIN_FAIL,
    UPDATE_ADMIN_PASSWORD_SUCCESS,
    UPDATE_ADMIN_PASSWORD_FAIL,
    UPDATE_ADMIN_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    adminListing: [],
    adminDetails: [],
    addAdmin: [],
    updateAdmin: [],
    updateAdminPwd: [],
    deleteAdmin: [],
    exportAdmin: [],
    error: [],
}

const Admin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ADMIN_LISTING_SUCCESS:
            return {
                ...state,
                adminListing: action.payload
            }
        case GET_ADMIN_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_ADMIN_DETAILS_SUCCESS:
            return {
                ...state,
                adminDetails: action.payload
            }
        case GET_ADMIN_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_ADMIN_SUCCESS:
            return {
                ...state,
                addAdmin: action.payload
            }
        case ADD_ADMIN_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_ADMIN_SUCCESS:
            return {
                ...state,
                updateAdmin: action.payload
            }
        case UPDATE_ADMIN_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_ADMIN_PASSWORD_SUCCESS:
            return {
                ...state,
                updateAdminPwd: action.payload
            }
        case UPDATE_ADMIN_PASSWORD_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_ADMIN_SUCCESS:
            return {
                ...state,
                deleteAdmin: action.payload
            }
        case DELETE_ADMIN_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteAdmin: action.payload
            }

        case EXPORT_ADMIN_SUCCESS:
            return {
                ...state,
                exportAdmin: action.payload
            }
        case EXPORT_ADMIN_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_ADMIN_STATE:
            return {
                ...state,
                adminListing: [],
                adminDetails: [],
                addAdmin: [],
                updateAdmin: [],
                updateAdminPwd: [],
                deleteAdmin: [],
                exportAdmin: [],
                error: [],
            }
        case RESET_ADMIN_ACTION_STATE:
            return {
                ...state,
                addAdmin: [],
                updateAdmin: [],
                updateAdminPwd: [],
                deleteAdmin: [],
                exportAdmin: [],
                error: [],
            }
        default:
            return state
    }
}

export default Admin
